export default {
    src: "https://monday.com/test/inside-iframe",
    height: "630px",
    borderWidth: "0px",
    borderColor: "transparent",
    hideScrolling: false
};
